import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const pdfTermsAndConditionsMixin = {
  methods: {
    async downloadTermsAndConditionsPDF(namePDF = 0, ref = 0,nameFile = '') {
      this.btnLoading = true;
      let content = null;
      if(ref == 1){
        content = this.$refs.pdfContent;
      }else{
        content = document.getElementById('pdf-content');
      }
      if (!content) {
        this.btnLoading = false;
        throw new Error("pdf-content missing");
      }
      const sections = content.querySelectorAll('.pdf-page-break'); // Secciones separadas por saltos de página

      // namePDF 3 = propuesta comercial: documento muy largo; PNG @ scale 2 supera el límite de
      // longitud de string al hacer pdf.save() (RangeError: Invalid string length en Array.join).
      const isProposalPdf = namePDF === 3;
      const html2canvasScale = isProposalPdf ? 1 : 2;
      const useJpeg = isProposalPdf;

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 0;
      const contentWidth = pageWidth - 2 * margin;
      const contentHeight = pageHeight - 2 * margin;

      let isFirstPage = true; // Control para agregar la primera página sin llamar a addPage()

      for (const section of sections) {
        // Generar un canvas completo para la sección
        const canvas = await html2canvas(section, {
          scale: html2canvasScale,
          useCORS: true,
          logging: false,
        });
        const imgWidth = contentWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let position = 0; // Altura procesada de la sección actual

        // Dividir la sección si es más alta que una página
        while (position < canvas.height) {
          const subCanvasHeight = Math.min(
            canvas.height - position,
            canvas.width * (contentHeight / imgWidth)
          );

          // Crear un sub-canvas para la parte actual del contenido
          const subCanvas = document.createElement('canvas');
          subCanvas.width = canvas.width;
          subCanvas.height = subCanvasHeight;

          const ctx = subCanvas.getContext('2d');
          ctx.drawImage(canvas, 0, -position);

          const subImgData = useJpeg
            ? subCanvas.toDataURL('image/jpeg', 0.82)
            : subCanvas.toDataURL('image/png');
          const imgFormat = useJpeg ? 'JPEG' : 'PNG';

          // Validar si la data URL es válida
          const dataOk = useJpeg
            ? subImgData.startsWith('data:image/jpeg;base64,')
            : subImgData.startsWith('data:image/png;base64,');
          if (!dataOk) {
            console.error('Invalid base64 string for section');
            break;
          }

          // Agregar la imagen al PDF
          if (!isFirstPage) {
            pdf.addPage(); // Agregar una nueva página después de la primera
          } else {
            isFirstPage = false; // Control para evitar addPage() en la primera página
          }

          pdf.addImage(
            subImgData,
            imgFormat,
            margin,
            margin,
            imgWidth,
            (subCanvasHeight * imgWidth) / canvas.width
          );

          // Avanzar a la siguiente parte de la sección
          position += subCanvasHeight;
        }
      }

      // Descargar el PDF generado
      switch (namePDF) {
        case 0:
          pdf.save('Terms&Conditions.pdf')
          this.btnLoading = false;
          break;
        case 1:
          pdf.save('ContratCollaboration_BookerFreelance.pdf')
          this.btnLoading = false;
          break;
        case 2:
          pdf.save(nameFile + '.pdf')
          this.btnLoading = false;
          break;
        case 3:
          pdf.save('termsAndConditionsProposal.pdf')
          this.btnLoading = false;
          break;
      }
    }
  }
};